// Copyright (c) BSS-ONE
// Author: Alexandru Bagu (a.bagu at software-dep.net)

<template>
  <div>
    <a-card class="breadcrumb-card">
      <a-row>
        <a-col :span="device === 'mobile' ? 24 : 12" style="padding-left: 12px">
          <breadcrumb :resource="{}">
            <template v-slot:end>
              <span>
                <a-button
                  :loading="isLoading"
                  style="margin-bottom: 5px"
                  shape="round"
                  size="small"
                  @click="fetchData({ irefresh: true })">
                  <template #icon><sync-outlined /></template>
                  {{ $t('label.refresh') }}
                </a-button>
              </span>
            </template>
          </breadcrumb>
        </a-col>
      </a-row>
    </a-card>
    <div>
      <a-row v-if="isEnabled == 0">
        <h2> {{ this.$t('label.ansible.disabled') }} </h2>
      </a-row>
      <table-view
        v-else
        :columns="columns"
        :data="rows"
        rowKey="id"
        :pageChanged="pageChanged" />
    </div>
  </div>
</template>

<script>
import { getAPI } from '@/api'
import { h } from 'vue'
import Breadcrumb from '@/components/widgets/Breadcrumb'
import TableView from '@/components/view/TableView'
import Status from '@/components/widgets/Status'
import { mixinDevice } from '@/utils/mixin.js'
import { Button } from 'ant-design-vue'

export default {
  name: 'List',
  components: {
    Breadcrumb,
    TableView,
    Status
  },
  mixins: [mixinDevice],
  data () {
    return {
      page: 1,
      hasMore: false,
      isEnabled: false,
      isLoading: false,
      rows: [],
      columns: []
    }
  },
  computed: {
  },
  mounted: function () {
    this.init(h)
  },
  methods: {
    init (h) {
      var that = this
      this.columns = [{
        dataIndex: 'id',
        title: this.$t('label.ansible.id'),
        customRender: function ({ text, record, index }) {
          return <span>{record.id}</span>
        }
      }, {
        dataIndex: 'name',
        title: this.$t('label.ansible.taskname'),
        customRender: function ({ text, record, index }) {
          return <span>{record.name}</span>
        }
      }, {
        dataIndex: 'created',
        title: this.$t('label.ansible.created'),
        customRender: function ({ text, record, index }) {
          var d = new Date(record.created)
          return <span>{d.toLocaleDateString()} {d.toLocaleTimeString()}</span>
        }
      }, {
        dataIndex: 'finished',
        title: this.$t('label.ansible.finished'),
        customRender: function ({ text, record, index }) {
          if (record.finished) {
            var d = new Date(record.finished)
            return <span>{d.toLocaleDateString()} {d.toLocaleTimeString()}</span>
          } else {
            return <status text={that.$t('label.ansible.task.running')} displayText=""></status>
          }
        }
      }, {
        dataIndex: 'failed',
        title: this.$t('label.ansible.failed'),
        customRender: function ({ text, record, index }) {
          if (record.finished) {
            return <span>{record.failed.toLocaleString()}</span>
          } else {
            return <span/>
          }
        }
      }, {
        customRender: function ({ text, record, index }) {
          var actions = []
          if (record.finished) {
            actions.push(h(Button, {
              onClick: () => { that.showFacts(record.id) }
            }, that.$t('label.ansible.facts')))
          }
          return h('span', {}, actions)
        }
      }]
      this.fetchData()
    },
    async fetchData () {
      this.rows.splice(0, this.rows.length)
      this.page = 1
      getAPI('ansibleStatus', {}).then(json => {
        this.isEnabled = json.ansiblestatusresponse.payload.isEnabled
        if (this.isEnabled) {
          this.fetchPage()
        }
      }).catch(error => {
        this.$notifyError(error)
      })
    },
    fetchPage () {
      var params = {}
      params.page = this.page
      var that = this
      getAPI('ansibleListTasks', params).then(function (json) {
        if (json && json.listansibletasksresponse && json.listansibletasksresponse.payload && json.listansibletasksresponse.payload.results) {
          var payload = json.listansibletasksresponse.payload
          var items = payload.results
          that.hasMore = payload.hasMore
          if (items.length) {
            for (var i in items) {
              that.rows.push(items[i])
            }
          }
        }
      })
    },
    pageChanged (page, pageSize) {
      if (this.hasMore && page === Math.round(this.rows.length / pageSize)) {
        this.page = (this.rows.length / 25) + 1
        this.fetchPage()
      }
    },
    showFacts (id) {
      var params = {}
      params.id = id
      getAPI('ansibleGetTaskFacts', params).then((json) => {
        if (json && json.ansibletaskfactsresponse && json.ansibletaskfactsresponse.payload) {
          var payload = json.ansibletaskfactsresponse.payload
          this.$info({
            title: `${this.$t('label.ansible.facts')} ${id}`,
            content: (<pre> <p>{JSON.stringify(payload)}</p></pre>)
          })
        } else {
          this.$notification.error(this.$t('label.ansible.factsmissing'))
        }
      })
    }
  }
}
</script>

<style scoped>
  .breadcrumb-card {
    margin-left: -24px;
    margin-right: -24px;
    margin-top: -16px;
    margin-bottom: 12px;
  }
  .row-element {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .ant-breadcrumb {
    vertical-align: text-bottom;
  }
</style>
<style>
.ant-badge-status-dot {
    width: 12px;
    height: 12px;
    margin-top: 5px;
  }
</style>
